

// import React from "react";
// import "./Products.css";

// const PRODUCTS = [
//   {
//     id: 1,
//     name: "Premium Sofa Design",
//     category: "Decor Essentials",
//     category_ur: "سجاوٹ کے لوازمات",
//     nameUr: "پریمیم سوفی ڈیزائن",
//     priceUr: "۱۲۰۰",
//     price: 1200,
//     img: "https://onlinepk.me/admin/upload/cate/1778568414181.jpg",
//   },
//   {
//     id: 2,
//     name: "HeadPhone",
//     category: "Mobile Accessories",
//     category_ur: "موبائل لوازمات",
//     nameUr: "ہیڈ فون",
//     priceUr: "۱۵۰۰",
//     price: 1500,
//     img: "https://onlinepk.me/admin/upload/cate/1778568548112.jpg",
//   },
//   {
//     id: 3,
//     name: "Cosmetic Kit",
//     category: "Jewelry and Cosmetic Organizers",
//     category_ur: "زیورات اور کاسمیٹک آرگنائزرز",
//     nameUr: "کاسمیٹک کٹ",
//    priceUr: "۲۰۰۰",
//     price: 2000,
//     img: "https://onlinepk.me/admin/upload/cate/1778567499563.jpg",
//   },
//   {
//     id: 4,
//     name: "Ceramic Tea Set",
//     category: "Kitchen Essentials",
//     category_ur: "باورچی خانے کے لوازمات",
//     nameUr: "سرامک ٹی سیٹ",
//     priceUr: "۹۹۹",
//     price: 999,
//     img: "https://onlinepk.me/admin/upload/cate/1778567044605.jpg",
//   },
//   {
//     id: 5,
//     name: "Head USB Fan",
//     category: "Household Needs",
//     category_ur: "گھریلو ضروریات",
//     nameUr: "ہیڈ یو ایس بی فین",
//     priceUr: "۲۰۰۰",
//     price: 2000,
//     img: "https://onlinepk.me/admin/upload/cate/1778567335516.jpg",
//   },
//   {
//     id: 6,
//     name: "Care",
//     category: "Personal Care",
//     category_ur: "ذاتی نگہداشت",
//     nameUr: "دیکھ بھال",
//     priceUr: "۳۰۰",
//     price: 300,
//     img: "https://onlinepk.me/admin/upload/cate/1778567701529.jpg",
//   },
//   {
//     id: 7,
//     name: "Luxury Bathroom Soap Dish",
//     category: "Bathroom Essentials",
//     category_ur: "باتھ روم کے لوازمات",
//     nameUr: "لگژری باتھ روم صابن ڈش",
//      priceUr: "۲۸۰",
//     price: 280,
//     img: "https://onlinepk.me/admin/upload/cate/1780297961557.jpg",
//   },
//   {
//     id: 8,
//     name: "Kids Toys",
//     category: "Kids and Babies Section",
//     category_ur: "بچوں اور نومولود سیکشن",
//     nameUr: "بچوں کے کھلونے",
//     priceUr: "۲۰۰",
//     price: 200,
//     img: "https://onlinepk.me/admin/upload/cate/1778568147455.jpg",
//   },
// ];

// export default function Products({
//   products = PRODUCTS,
//   addToCart,
//   language,
//   translations,
// }) {
//   const isUrdu =
//     language?.toLowerCase() === "ur" ||
//     language?.toLowerCase() === "urdu";

//   const getProductName = (item) => {
//     if (!isUrdu) return item.name;

//     const itemId = String(item?.id);

//     const translatedName =
//       translations?.ur?.productsData?.[itemId]?.name;

//     return translatedName || item?.nameUr || item?.name;
//   };

  

//   return (
//     <div className="products-container">
//       <h2 className="products-title">
//         {isUrdu ? "تمام مصنوعات" : "Flash Sale"}
//       </h2>

//       <div className="products-grid">
//         {products.map((item) => (
//           <div className="product-card" key={item.id}>
//             <img
//               src={item.img}
//               alt={getProductName(item)}
//               className="product-image"
//             />

//             <h3>{getProductName(item)}</h3>

//             <div className="price">
//               {isUrdu
//                 ? `${item.priceUr || item.price} روپے `
//                 : `Rs ${item.price}`}
//             </div>

//             <button
//               className="add-btn"
//               onClick={() => addToCart(item)}
//             >
//               {isUrdu
//                 ? "کارٹ میں شامل کریں"
//                 : "Add To Cart"}
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Products.css";

const API_BASE = "https://onlinepk.me/admin/api";

export default function Products({
  addToCart,
  language,
  translations,
}) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const isUrdu =
    language?.toLowerCase() === "ur" ||
    language?.toLowerCase() === "urdu";

  useEffect(() => {
    axios
      .get(`${API_BASE}/products`)
      .then((res) => {
        console.log("Products API:", res.data);

        setProducts(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const getProductName = (item) => {
    if (!isUrdu) return item.name;

    const id = String(item.id);

    return (
      translations?.ur?.productsData?.[id]?.name ||
      item.nameUr ||
      item.name
    );
  };

  const getImage = (item) => {
    if (item.image_url) return item.image_url;

    if (item.img)
      return `https://onlinepk.me/admin/upload/item/${item.img}`;

    return "/no-image.png";
  };

  if (loading) {
    return (
      <div className="container text-center mt-5">
        <h4>Loading Products...</h4>
      </div>
    );
  }

  return (
    <div className="products-container">

      <h2 className="products-title">
        {isUrdu ? "تمام مصنوعات" : "Flash Sale"}
      </h2>

      <div className="products-grid">
{products.length > 0 ? (
  products.map((product) => (
    <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={product.id}>
      <div className="card h-100 shadow-sm">

        <img
  src={
    product.img
      ? `https://onlinepk.me/admin/upload/item/${product.img}`
      : "/no-image.png"
  }
  alt={product.name}
  className="card-img-top"
  style={{ height: "220px", objectFit: "cover" }}
  onError={(e) => {
    e.target.src = "/no-image.png";
  }}
/>

        <div className="card-body">
          <h5 className="card-title">{product.name}</h5>

          {/* <p className="card-text">
            {product.description}
          </p> */}

          <p>
            <strong>MRP:</strong> Rs. {product.mrp}
          </p>

          <p>
            <strong>Small Price:</strong> Rs. {product.smallPrice}
          </p>

          <p>
            <strong>Medium Price:</strong> Rs. {product.mediumPrice}
          </p>

          <p>
            <strong>Large Price:</strong> Rs. {product.largePrice}
          </p>

        <button
             className="add-btn"
              onClick={() => addToCart(product)}
           >
             {isUrdu
               ? "کارٹ میں شامل کریں"
                              : "Add To Cart"}
                              </button>
        </div>

      </div>
    </div>
  ))
) : (
  <div className="col-12 text-center">
    <h3>No Products Found</h3>
  </div>
)}
      </div>

    </div>
  );
}